import React from 'react'
import { Trans } from '@lingui/macro'
import { useDispatch, useSelector } from 'react-redux'
import { ButtonLink } from 'components/UI/ButtonLink/ButtonLink'
import { getColor } from 'components/utils'
import { Alert } from 'components/UI/Alert/Alert'

import { DotsVerticalIcon, MinusSmIcon } from '@heroicons/react/outline'
import { IdRefundsState } from 'model/dashboardRefunds/dRefundsReducer'
import {
    dRefundsSetDetailItemAC
} from 'model/dashboardRefunds/dRefundsActionCreators'
import { numberCurrencyFormat } from 'constants/convertToLocalCurrency';


// Type
export type typeTableHeader = {
    variant?: string

}

// Header data component
export const TableHeader: React.FC<typeTableHeader> = () => {

    return (
        <>
            <th scope="col"
                className="px-4 py-3  text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Date</Trans>
            </th>
            {process.env.REACT_APP_CUSTOMER !== 'SKAPPSK' && <th scope="col"
                  className="px-4 py-3  text-left text-xs font-medium uppercase tracking-wider ">
                <Trans>Fiscal module ID</Trans>
            </th> }
            <th scope="col"
                className="px-4 py-3  text-left text-xs font-medium uppercase tracking-wider ">
                <Trans>Sum</Trans>
            </th>
            <th scope="col"
                className="px-4 py-3  text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Number of products</Trans>
            </th>

            <th scope="col"
                className="px-4 py-3  text-left text-xs font-medium  uppercase tracking-wider ">
                <Trans>Store</Trans>
            </th>

            <th scope="col"
                className="w-1 px-4 py-3 text-xs font-medium uppercase tracking-wider text-center">

            </th>
        </>
    )
}


// Type
export type typeAction = {
    title: JSX.Element,
    disableSwitcher?: boolean,
    action: (id: string) => void,
}

export type typeTableBody = {
    variant?: string
    rowsActions: typeAction[]
    setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>
}


// Body data component
export const TableBody: React.FC<typeTableBody> = ({ variant, rowsActions, setOpenPopupDetails }) => {

    const color = getColor(variant)

    const dispatch = useDispatch()

    const tableData = useSelector((state: { dRefunds: IdRefundsState }) => state.dRefunds.data)


    let component


    const onCellClickHandler = (e: React.MouseEvent<HTMLTableDataCellElement, MouseEvent>, id: string) => {
        dispatch(dRefundsSetDetailItemAC(id))
        setOpenPopupDetails(true)
    }

    if (tableData.length) {
        component = tableData.map((item, index) => {
            return (
                <tr key={ item.id }
                    className={ `${ index % 2 === 0 ? 'bg-white' : 'bg-gray-50' } hover:bg-${ color }-50` }>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>{item.date? item.date.substring(0, 19)
                        .replace('T', ' ') : <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div>}</td>
                    {process.env.REACT_APP_CUSTOMER !== 'SKAPPSK' && <td className="px-4 py-3 whitespace-nowrap text-sm  text-gray-500 cursor-pointer"
                          onClick={ (e) => onCellClickHandler(e, item.id) }>{ item.fmId ? item.fmId :
                        <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div> }</td>
                    }
                    <td className="px-4 py-3 whitespace-nowrap text-sm  text-gray-900 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>{ item.amount? numberCurrencyFormat(+item.amount):<div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div>}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>{ item.productsCount }</td>

                    <td className="px-4 py-3 text-sm  text-gray-500 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>{ item.store? item.store.name : <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div>}
                    </td>

                    <td className=" whitespace-nowrap text-sm text-gray-500 pr-2">
                        <div className="relative flex ">
                            <div
                                className="row-action-block">
                                <DotsVerticalIcon className="row-action-list-open-button"/>
                                <div className=" row-action-list">
                                    <div className="flex gap-x-4">
                                        { rowsActions.map((actionItem, ActionIndex) => {
                                                              return (
                                                                  <ButtonLink key={ ActionIndex } type={ 'button' }
                                                                              label={ actionItem.title }
                                                                              onClick={ () => actionItem.action(item.id) }/>
                                                              )
                                                          }
                                        ) }
                                    </div>
                                </div>
                            </div>
                        </div>

                    </td>
                </tr>
            )
        })
    } else {
        component = <tr>
            <td className="p-2" colSpan={ process.env.REACT_APP_CUSTOMER === 'SKAPPSK'? 6:7 }>
                <Alert className="w-full" type={ 'info' } title={ <Trans>The Refunds list is empty. Check filters.</Trans> }/>
            </td>
        </tr>
    }

    return (
        <>
            { component }
        </>
    )
}
